<template>
    <Button label="Редактировать" icon="pi pi-pencil" class="text-xs border-round-lg" @click="showDialog" severity="info" size="small" outlined/>

    <Dialog class="flex flex-column border-none" modal
        v-model:visible="dialog"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: '900px' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <div class="flex flex-column w-full mb-3">
                <span class="flex text-lg font-medium">Редактировать пользователя</span>
            </div>
        </template>

        <div class="flex flex-column w-full gap-3">
            <div class="flex flex-column w-full gap-2">
                <span class="flex">Email <span class="text-red-500">*</span>: </span>
                <InputText v-model="userData.email" type="email" placeholder="user@example.com" class="w-full"/>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Логин: </span>
                <InputText v-model="userData.login" placeholder="username" class="w-full"/>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Имя: </span>
                <InputText v-model="userData.name" placeholder="Имя пользователя" class="w-full"/>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Success URL: </span>
                <InputText v-model="userData.success_url" placeholder="https://example.com/success" class="w-full"/>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Fail URL: </span>
                <InputText v-model="userData.fail_url" placeholder="https://example.com/fail" class="w-full"/>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Webhook URL: </span>
                <InputText v-model="userData.webhook_url" placeholder="https://example.com/webhook" class="w-full"/>
            </div>

            <Divider />

            <div class="flex flex-column w-full gap-3">
                <div class="flex justify-content-between align-items-center">
                    <span class="text-lg font-medium">Платежные системы</span>
                    <Button label="Добавить" icon="pi pi-plus" @click="addPaymentSystem" size="small" severity="success"/>
                </div>

                <div v-for="(ps, index) in userData.payment_systems" :key="index" class="flex flex-column w-full gap-2 p-3 border-1 surface-border border-round">
                    <div class="flex justify-content-between align-items-center mb-2">
                        <span class="font-medium">Система #{{ index + 1 }}</span>
                        <Button icon="pi pi-trash" @click="removePaymentSystem(index)" size="small" severity="danger" text/>
                    </div>

                    <div class="flex flex-column w-full gap-2">
                        <span class="flex text-sm">Система <span class="text-red-500">*</span>: </span>
                        <Select v-model="ps.system" :options="systemOptions" placeholder="Выберите систему" class="w-full"/>
                    </div>

                    <div class="flex flex-column w-full gap-2">
                        <span class="flex text-sm">Merchant ID <span class="text-red-500">*</span>: </span>
                        <InputText v-model="ps.merchant_id" placeholder="merchant_id" class="w-full"/>
                    </div>

                    <div class="flex align-items-center gap-2">
                        <Checkbox v-model="ps.kyc_required" :binary="true" inputId="kyc_required_{{index}}"/>
                        <label :for="'kyc_required_' + index" class="text-sm">Требуется KYC</label>
                    </div>

                    <div class="flex w-full gap-2
                        flex-column xl:flex-row lg:flex-row">
                        <div class="flex flex-column flex-1 gap-2">
                            <span class="flex text-sm">Мин. лимит (₽): </span>
                            <InputNumber v-model="ps.min_limit" class="w-full" :min="0" placeholder="100"/>
                        </div>
                        <div class="flex flex-column flex-1 gap-2">
                            <span class="flex text-sm">Макс. лимит (₽): </span>
                            <InputNumber v-model="ps.max_limit" class="w-full" :min="0" placeholder="1000000"/>
                        </div>
                    </div>

                    <div class="flex flex-column w-full gap-2">
                        <span class="flex text-sm">Параметры (JSON): </span>
                        <Textarea v-model="ps.paramsJson" rows="3" placeholder='{"key": "value"}' class="w-full"/>
                        <small v-if="ps.paramsError" class="text-red-500">{{ ps.paramsError }}</small>
                    </div>
                </div>

                <div v-if="!userData.payment_systems || userData.payment_systems.length === 0" class="text-center text-500 p-3">
                    Нет добавленных платежных систем
                </div>
            </div>
        </div>

        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Сохранить" @click='UpdateUser()' :loading="loading" class="flex" :disabled="loading || !isValid" severity="info"/>
                <Button label="Закрыть" icon="pi pi-times" @click="dialog = false" outlined class="flex" autofocus severity="secondary" :disabled="loading"/>
            </div>
        </template>

    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'

export default {
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            dialog: false,
            userData: {
                email: '',
                login: '',
                name: '',
                payment_systems: [],
                success_url: '',
                fail_url: '',
                webhook_url: ''
            },
            accessCodeOptions: ['admin', 'personal', 'merchant', 'viewer'],
            systemOptions: ['tbank', 'dolinsk_bank', 'kanyonpay', 'easy_pay', 'panacea_pay', 'loveandpay', 'netpay'],
        }
    },
    computed: {
        screenSize() { return this.$store.getters.StateScreenSize },
        isValid() {
            if(!this.userData.email || !this.validateEmail(this.userData.email)) return false
            
            // Проверка платежных систем
            if(this.userData.payment_systems && this.userData.payment_systems.length > 0) {
                for(const ps of this.userData.payment_systems) {
                    if(!ps.system || !ps.merchant_id) return false
                    if(ps.paramsError) return false
                }
            }
            
            return true
        }
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return re.test(email)
        },
        showDialog(){
            this.dialog = true
            this.loadUserData()
        },
        loadUserData() {
            if(!this.user) return
            
            this.userData = {
                email: this.user.email || '',
                login: this.user.login || '',
                name: this.user.name || '',
                payment_systems: [],
                success_url: this.user.success_url || '',
                fail_url: this.user.fail_url || '',
                webhook_url: this.user.webhook_url || ''
            }

            // Загружаем платежные системы
            if(this.user.payment_systems && this.user.payment_systems.length > 0) {
                this.userData.payment_systems = this.user.payment_systems.map(ps => ({
                    system: ps.system || ps.code || '',
                    kyc_required: ps.kyc_required !== undefined ? ps.kyc_required : true,
                    merchant_id: ps.merchant_id || '',
                    min_limit: ps.min_limit || 100,
                    max_limit: ps.max_limit || 1000000,
                    paramsJson: ps.params ? JSON.stringify(ps.params, null, 2) : '{}',
                    paramsError: null
                }))
            }
        },
        addPaymentSystem() {
            this.userData.payment_systems.push({
                system: '',
                kyc_required: true,
                merchant_id: '',
                min_limit: 100,
                max_limit: 1000000,
                paramsJson: '{}',
                paramsError: null
            })
        },
        removePaymentSystem(index) {
            this.userData.payment_systems.splice(index, 1)
        },
        validatePaymentSystems() {
            let valid = true
            for(const ps of this.userData.payment_systems) {
                try {
                    JSON.parse(ps.paramsJson || '{}')
                    ps.paramsError = null
                } catch(e) {
                    ps.paramsError = 'Неверный формат JSON'
                    valid = false
                }
            }
            return valid
        },
        async UpdateUser(){
            this.loading = true
            
            if(!this.userData.email){
                this.showMess('error', 'Ошибка', 'Email обязателен')
                this.loading = false
                return
            }

            if(!this.validateEmail(this.userData.email)){
                this.showMess('error', 'Ошибка', 'Неверный формат email')
                this.loading = false
                return
            }

            if(!this.validatePaymentSystems()) {
                this.showMess('error', 'Ошибка', 'Проверьте параметры платежных систем')
                this.loading = false
                return
            }

            // Подготовка данных для отправки
            const updateData = {
                id: this.user.id,
                email: this.userData.email,
                login: this.userData.login || null,
                name: this.userData.name || null,
                success_url: this.userData.success_url || null,
                fail_url: this.userData.fail_url || null,
                webhook_url: this.userData.webhook_url || null,
                payment_systems: this.userData.payment_systems.map(ps => ({
                    system: ps.system,
                    kyc_required: ps.kyc_required,
                    merchant_id: ps.merchant_id,
                    min_limit: ps.min_limit,
                    max_limit: ps.max_limit,
                    params: JSON.parse(ps.paramsJson || '{}')
                }))
            }

            try{
                const update = await this.connect.EditAdminUser(updateData).then(res=>res)
                if(update.result && update.data){
                    this.showMess('success', 'Успешно', 'Пользователь обновлен')
                    this.$emit('updated', update.data)
                    this.dialog = false
                } else {
                    if(update.message){
                        this.showMess('error', 'Ошибка', update.message)
                    } else {
                        this.showMess('error', 'Ошибка', 'Ошибка при обновлении пользователя')
                    }
                } 
            } catch(e){
                this.showMess('error', 'Ошибка', 'Ошибка при обновлении пользователя')
                console.log('error', e)
            }  
            this.loading = false
        }
    },
    async mounted() {
        
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>
